<template>
    <div class="left_panel">
        <div class="new_myaddress_heading_box d-flex justify-content-between">
            <div>
                <h2 class="font_size_20 font-weight-bold mb-0">My Addresses</h2>
                <div class="subhead font_size_16 text_light_grey mb-0">
                    View and manage the saved addresses in your account.
                </div>
            </div>

            <div
                class="panel_head_right upload_img_panel d-flex align-items-center add_address_model_btn"
            >
                <a
                    href="javascript:void(0);"
                    data-toggle="modal"
                    data-target="#add-address-modal"
                    class="btn btn_orange bg_primary_orange text_white"
                    >+ Add Address</a
                >
            </div>
        </div>

        <div class="payment_cards myaddress_main_box mt_30">
            <div class="d-flex flex-wrap">
                <div
                    class="mr_26 myaddress_main_inner_box"
                    v-for="(address, indx) in addresses"
                    :key="indx"
                >
                    <div class="payment_box">
                        <h4 class="font_size_20 font-weight-bold mb-0 mt_22">
                            {{ address.address_label }}
                        </h4>
                        <span
                            v-if="address.first_name || address.last_name"
                            class="d-block"
                        >
                            {{
                                [address.first_name, address.last_name]
                                    .filter(Boolean)
                                    .join(" ")
                            }}
                        </span>
                        <span class="d-block">{{ address.address1 }}</span>
                        <span class="d-block">{{ address.address2 }}</span>
                        <span
                            v-if="
                                address.city || address.state || address.pincode
                            "
                        >
                            {{
                                [
                                    address.city,
                                    address.state
                                        ? address.state +
                                          (address.pincode
                                              ? " " + address.pincode
                                              : "")
                                        : ""
                                ]
                                    .filter(Boolean)
                                    .join(", ")
                            }}
                        </span>
                        <span class="d-block">{{ address.address_type }}</span>
                        <div class="payment_icons">
                            <a
                                class="mr_14"
                                href="javascript::void(0)"
                                data-toggle="modal"
                                :data-target="`#update-address-modal${address.id}`"
                                v-tooltip="'Edit'"
                                ><img
                                    src="/maincss/images/edit_payment.svg"
                                    alt=" "
                            /></a>
                            <a
                                href="#"
                                v-tooltip="'Delete'"
                                data-toggle="modal"
                                :data-target="`#delete-address-${address.id}`"
                                class="delete-link"
                                ><img
                                    src="/maincss/images/payment_delete.svg"
                                    alt=" "
                            /></a>
                            <DeleteResource
                                :target="'delete-address-' + address.id"
                                :path="'/delete-user-address/' + address.id"
                                @updatelist="getAddresses()"
                            />
                        </div>
                    </div>

                    <!-- UPdate Address Model -->
                    <div
                        class="modal login-form-popup fade new_edit_address_popup"
                        :id="`update-address-modal${address.id}`"
                        tabindex="-1"
                        aria-labelledby="address"
                        aria-hidden="true"
                        data-keyboard="false"
                    >
                        <div
                            class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                        >
                            <div class="modal-content">
                                <div class="modal-body">
                                    <a
                                        href="#"
                                        class="popup-close"
                                        id="popup-close-paymentform"
                                        @click="
                                            getAddresses();
                                            resetSuggestions();
                                        "
                                        data-dismiss="modal"
                                    >
                                        <img
                                            src="/maincss/images/cancel.svg"
                                            alt=" "
                                        />
                                    </a>
                                    <div
                                        class="address-form add_new_address_popup_design"
                                    >
                                        <h3 class="text-center">
                                            Edit Address
                                        </h3>
                                        <form
                                            method="post"
                                            @submit.prevent="
                                                updateUserAddress(address)
                                            "
                                            :data-vv-scope="`updateaddressform${address.id}`"
                                        >
                                            <div
                                                class="card-body edit_profile_card_body"
                                            >
                                                <!-- Row 1: Address Type (alone) -->
                                                <div class="row edit_name_row">
                                                    <div
                                                        class="col-md-12 col-lg-6"
                                                    >
                                                        <div
                                                            class="form-group edit_state_zip_div state_formgroup"
                                                        >
                                                            <fieldset>
                                                                <v-select
                                                                    :options="
                                                                        address_types
                                                                    "
                                                                    :placeholder="'Select Address Type'"
                                                                    name="address_type"
                                                                    v-validate="
                                                                        'required'
                                                                    "
                                                                    v-model="
                                                                        address.address_type
                                                                    "
                                                                    data-vv-as="Address Type"
                                                                    @input="
                                                                        onChangeAddressType(
                                                                            address.address_type,
                                                                            address.id
                                                                        )
                                                                    "
                                                                ></v-select>
                                                                <label
                                                                    class="state_label_new"
                                                                    >Address
                                                                    Type
                                                                </label>
                                                                <small
                                                                    class="form-text text-error text-left"
                                                                    v-show="
                                                                        address_type_error
                                                                    "
                                                                    >{{
                                                                        address_type_error
                                                                    }}</small
                                                                >
                                                                <small
                                                                    class="form-text text-error text-left"
                                                                    v-show="
                                                                        errors.has(
                                                                            `updateaddressform${address.id}.address_type`
                                                                        )
                                                                    "
                                                                    >{{
                                                                        errors.first(
                                                                            `updateaddressform${address.id}.address_type`
                                                                        )
                                                                    }}</small
                                                                >
                                                            </fieldset>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Row 2: Address Title (Optional) (left) + Company Name (right) -->
                                                <div class="row edit_name_row">
                                                    <div
                                                        class="col-md-12 col-lg-6"
                                                    >
                                                        <div class="form-group">
                                                            <input
                                                                type="text"
                                                                id="address_title"
                                                                name="address_title"
                                                                class="form-control bg-transparent"
                                                                placeholder="Enter Address Title (Optional)"
                                                                v-model="
                                                                    address.address_title
                                                                "
                                                                data-vv-as="Address Title"
                                                            />
                                                            <label
                                                                >Address Title (Optional)
                                                            </label>
                                                            <span
                                                                class="highlight"
                                                            ></span>
                                                            <small
                                                                class="form-text text-error text-left"
                                                                v-show="
                                                                    errors.has(
                                                                        `updateaddressform${address.id}.address_title`
                                                                    )
                                                                "
                                                                >{{
                                                                    errors.first(
                                                                        `updateaddressform${address.id}.address_title`
                                                                    )
                                                                }}</small
                                                            >
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-md-12 col-lg-6"
                                                    >
                                                        <div class="form-group">
                                                            <input
                                                                type="text"
                                                                id="address_label"
                                                                name="address_label"
                                                                class="form-control bg-transparent"
                                                                v-validate="
                                                                    'required|max:150'
                                                                "
                                                                v-model="
                                                                    address.address_label
                                                                "
                                                                data-vv-as="Company Name"
                                                                placeholder="Enter Company Name"
                                                            />
                                                            <label
                                                                >Company Name
                                                            </label>
                                                            <span
                                                                class="highlight"
                                                            ></span>
                                                            <small
                                                                class="form-text text-error text-left"
                                                                v-show="
                                                                    errors.has(
                                                                        `updateaddressform${address.id}.address_label`
                                                                    )
                                                                "
                                                                >{{
                                                                    errors.first(
                                                                        `updateaddressform${address.id}.address_label`
                                                                    )
                                                                }}</small
                                                            >
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Row 3: First Name (left) + Last Name (right) -->
                                                <div class="row edit_name_row">
                                                    <div
                                                        class="col-md-12 col-lg-6"
                                                    >
                                                        <div class="form-group">
                                                            <input
                                                                type="text"
                                                                id="first_name"
                                                                name="first_name"
                                                                class="form-control bg-transparent"
                                                                v-validate="
                                                                    'required|max:150'
                                                                "
                                                                v-model="
                                                                    address.first_name
                                                                "
                                                                data-vv-as="First Name"
                                                                placeholder="Enter First Name"
                                                            />
                                                            <label
                                                                >First Name
                                                            </label>
                                                            <span
                                                                class="highlight"
                                                            ></span>
                                                            <small
                                                                class="form-text text-error text-left"
                                                                v-show="
                                                                    errors.has(
                                                                        `updateaddressform${address.id}.first_name`
                                                                    )
                                                                "
                                                                >{{
                                                                    errors.first(
                                                                        `updateaddressform${address.id}.first_name`
                                                                    )
                                                                }}</small
                                                            >
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-md-12 col-lg-6"
                                                    >
                                                        <div class="form-group">
                                                            <input
                                                                type="text"
                                                                id="last_name"
                                                                name="last_name"
                                                                class="form-control bg-transparent"
                                                                v-validate="
                                                                    'required|max:150'
                                                                "
                                                                v-model="
                                                                    address.last_name
                                                                "
                                                                data-vv-as="Last Name"
                                                                placeholder="Enter Last Name"
                                                            />
                                                            <label
                                                                >Last Name
                                                            </label>
                                                            <span
                                                                class="highlight"
                                                            ></span>
                                                            <small
                                                                class="form-text text-error text-left"
                                                                v-show="
                                                                    errors.has(
                                                                        `updateaddressform${address.id}.last_name`
                                                                    )
                                                                "
                                                                >{{
                                                                    errors.first(
                                                                        `updateaddressform${address.id}.last_name`
                                                                    )
                                                                }}</small
                                                            >
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Row 4: Address 1 (left) + Address 2 (right) -->
                                                <div class="row edit_name_row">
                                                    <div
                                                        class="col-md-12 col-lg-6"
                                                    >
                                                        <div class="form-group">
                                                            <input
                                                                type="text"
                                                                id="address1"
                                                                name="address1"
                                                                class="form-control bg-transparent"
                                                                v-validate="
                                                                    'required|max:150'
                                                                "
                                                                v-model="
                                                                    address.address1
                                                                "
                                                                data-vv-as="Address1"
                                                                placeholder="Enter Address 1"
                                                            />
                                                            <label
                                                                >Address 1<img
                                                                    v-if="
                                                                        address.address_verified ===
                                                                        1
                                                                    "
                                                                    src="/maincss/images/success_1.svg"
                                                                    alt=" "
                                                            /></label>
                                                            <span
                                                                class="highlight"
                                                            ></span>
                                                            <small
                                                                class="form-text text-error text-left"
                                                                v-show="
                                                                    errors.has(
                                                                        `updateaddressform${address.id}.address1`
                                                                    )
                                                                "
                                                                >{{
                                                                    errors.first(
                                                                        `updateaddressform${address.id}.address1`
                                                                    )
                                                                }}</small
                                                            >
                                                            <small
                                                                class="form-text text-error text-left font-weight-bold"
                                                                v-if="
                                                                    address1_suggestion
                                                                "
                                                                >Suggestion:
                                                                {{
                                                                    address1_suggestion
                                                                }}</small
                                                            >
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-md-12 col-lg-6"
                                                    >
                                                        <div class="form-group">
                                                            <input
                                                                type="text"
                                                                id="address2"
                                                                name="address2"
                                                                placeholder="Enter Address 2"
                                                                class="form-control bg-transparent"
                                                                v-model="
                                                                    address.address2
                                                                "
                                                                data-vv-as="Address2"
                                                            />
                                                            <label
                                                                >Address 2<img
                                                                    v-if="
                                                                        address.address_verified ===
                                                                        1
                                                                    "
                                                                    src="/maincss/images/success_1.svg"
                                                                    alt=" "
                                                            /></label>
                                                            <span
                                                                class="highlight"
                                                            ></span>
                                                            <small
                                                                class="form-text text-error text-left"
                                                                v-show="
                                                                    errors.has(
                                                                        `updateaddressform${address.id}.address2`
                                                                    )
                                                                "
                                                                >{{
                                                                    errors.first(
                                                                        `updateaddressform${address.id}.address2`
                                                                    )
                                                                }}</small
                                                            >
                                                            <small
                                                                class="form-text text-error text-left font-weight-bold"
                                                                v-if="
                                                                    address2_suggestion
                                                                "
                                                                >Suggestion:
                                                                {{
                                                                    address2_suggestion
                                                                }}</small
                                                            >
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Row 5: City (left) + State (right) -->
                                                <div class="row edit_name_row">
                                                    <div
                                                        class="col-md-12 col-lg-6"
                                                    >
                                                        <div class="form-group">
                                                            <input
                                                                type="text"
                                                                id="city"
                                                                name="city"
                                                                class="form-control bg-transparent"
                                                                placeholder="Enter City"
                                                                v-validate="
                                                                    'required|max:150'
                                                                "
                                                                v-model="
                                                                    address.city
                                                                "
                                                                data-vv-as="City"
                                                            />
                                                            <label
                                                                >City<img
                                                                    v-if="
                                                                        address.address_verified ===
                                                                        1
                                                                    "
                                                                    src="/maincss/images/success_1.svg"
                                                                    alt=" "
                                                            /></label>
                                                            <span
                                                                class="highlight"
                                                            ></span>
                                                            <small
                                                                class="form-text text-error text-left"
                                                                v-show="
                                                                    errors.has(
                                                                        `updateaddressform${address.id}.city`
                                                                    )
                                                                "
                                                                >{{
                                                                    errors.first(
                                                                        `updateaddressform${address.id}.city`
                                                                    )
                                                                }}</small
                                                            >
                                                            <small
                                                                class="form-text text-error text-left font-weight-bold"
                                                                v-if="
                                                                    city_suggestion
                                                                "
                                                                >Suggestion:
                                                                {{
                                                                    city_suggestion
                                                                }}</small
                                                            >
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-md-12 col-lg-6"
                                                    >
                                                        <div
                                                            class="form-group edit_state_zip_div state_formgroup"
                                                        >
                                                            <fieldset>
                                                                <v-select
                                                                    autocomplete="US"
                                                                    label="code"
                                                                    :reduce="
                                                                        (
                                                                            name
                                                                        ) =>
                                                                            name.code
                                                                    "
                                                                    :options="
                                                                        states
                                                                    "
                                                                    :placeholder="'Select State'"
                                                                    name="state"
                                                                    v-validate="
                                                                        'required'
                                                                    "
                                                                    v-model="
                                                                        address.state
                                                                    "
                                                                    data-vv-as="State"
                                                                ></v-select>
                                                                <label
                                                                    class="state_label_new"
                                                                    >State<img
                                                                        v-if="
                                                                            address.address_verified ===
                                                                            1
                                                                        "
                                                                        src="/maincss/images/success_1.svg"
                                                                        alt=" "
                                                                /></label>
                                                                <small
                                                                    class="form-text text-error text-left"
                                                                    v-show="
                                                                        errors.has(
                                                                            `updateaddressform${address.id}.state`
                                                                    )
                                                                "
                                                                >{{
                                                                    errors.first(
                                                                        `updateaddressform${address.id}.state`
                                                                    )
                                                                }}</small
                                                            >
                                                            <small
                                                                class="form-text text-error text-left font-weight-bold"
                                                                v-if="
                                                                    state_suggestion
                                                                "
                                                                >Suggestion:
                                                                {{
                                                                    state_suggestion
                                                                }}</small
                                                            >
                                                        </fieldset>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Row 6: Zip / Postal code (left column) -->
                                                <div class="row edit_name_row">
                                                    <div
                                                        class="col-md-12 col-lg-6"
                                                    >
                                                        <div class="form-group">
                                                            <input
                                                                type="text"
                                                                id="zipcode"
                                                                name="zipcode"
                                                                placeholder="Enter Zipcode"
                                                                class="form-control bg-transparent mb-0"
                                                                v-validate="
                                                                    'required|max:7|integer'
                                                                "
                                                                v-model="
                                                                    address.pincode
                                                                "
                                                                data-vv-as="Zipcode"
                                                            />

                                                            <label
                                                                >Zip / Postal
                                                                code<img
                                                                    v-if="
                                                                        address.address_verified ===
                                                                        1
                                                                    "
                                                                    src="/maincss/images/success_1.svg"
                                                                    alt=" "
                                                            /></label>
                                                            <span
                                                                class="highlight"
                                                            ></span>
                                                            <small
                                                                class="form-text text-error text-left"
                                                                v-show="
                                                                    errors.has(
                                                                        `updateaddressform${address.id}.zipcode`
                                                                    )
                                                                "
                                                                >{{
                                                                    errors.first(
                                                                        `updateaddressform${address.id}.zipcode`
                                                                    )
                                                                }}</small
                                                            >
                                                            <small
                                                                class="form-text text-error text-left font-weight-bold"
                                                                v-if="
                                                                    pincode_suggestion
                                                                "
                                                                >Suggestion:
                                                                {{
                                                                    pincode_suggestion
                                                                }}</small
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="text-center">
                                                <button
                                                    type="submit"
                                                    class="btn btn_orange bg_primary_orange text_white px_60 mt_34 mb_32 btn_h60"
                                                >
                                                    Update
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Add Address Model -->
        <div
            class="modal login-form-popup"
            id="add-address-modal"
            tabindex="-1"
            aria-labelledby="address"
            aria-hidden="true"
            data-keyboard="false"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <a
                            href="#"
                            class="popup-close"
                            id="popup-close-paymentform"
                            data-dismiss="modal"
                            @click="resetAddress"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>
                        <div class="address-form add_new_address_popup_design">
                            <h3 class="text-center">Add New Address</h3>
                            <form
                                method="post"
                                @submit.prevent="addUserAddress"
                                data-vv-scope="addaddressform"
                            >
                                <div
                                    class="card-body edit_profile_card_body p-0"
                                >
                                    <!-- Row 1: Address Type (alone) -->
                                    <div class="row edit_name_row">
                                        <div class="col-md-12 col-lg-6">
                                            <div
                                                class="form-group edit_state_zip_div state_formgroup"
                                            >
                                                <fieldset>
                                                    <v-select
                                                        :options="address_types"
                                                        :placeholder="'Select Address Type'"
                                                        name="address_type"
                                                        v-validate="'required'"
                                                        v-model="
                                                            new_address.address_type
                                                        "
                                                        data-vv-as="Address Type"
                                                        @input="
                                                            onChangeAddressType(
                                                                new_address.address_type
                                                            )
                                                        "
                                                    ></v-select>
                                                    <label
                                                        class="state_label_new"
                                                        >Address Type
                                                    </label>
                                                    <small
                                                        class="form-text text-error text-left"
                                                        v-show="
                                                            address_type_error
                                                        "
                                                        >{{
                                                            address_type_error
                                                        }}</small
                                                    >
                                                    <small
                                                        class="form-text text-error text-left"
                                                        v-show="
                                                            errors.has(
                                                                'addaddressform.address_type'
                                                            )
                                                        "
                                                        >{{
                                                            errors.first(
                                                                "addaddressform.address_type"
                                                            )
                                                        }}</small
                                                    >
                                                </fieldset>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Row 2: Address Title (Optional) (left) + Company Name (right) -->
                                    <div class="row edit_name_row">
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="address_title"
                                                    name="address_title"
                                                    class="form-control bg-transparent"
                                                    placeholder="Enter Address Title (Optional)"
                                                    v-model="
                                                        new_address.address_title
                                                    "
                                                    data-vv-as="Address Title"
                                                />
                                                <label>Address Title (Optional)</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addaddressform.address_title'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "addaddressform.address_title"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="address_label"
                                                    name="address_label"
                                                    class="form-control bg-transparent"
                                                    v-validate="
                                                        'required|max:150'
                                                    "
                                                    placeholder="Enter Company Name"
                                                    v-model="
                                                        new_address.address_label
                                                    "
                                                    data-vv-as="Company Name"
                                                />
                                                <label>Company Name</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addaddressform.address_label'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "addaddressform.address_label"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Row 3: First Name (left) + Last Name (right) -->
                                    <div class="row edit_name_row">
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="first_name"
                                                    name="first_name"
                                                    class="form-control bg-transparent"
                                                    v-validate="
                                                        'required|max:150'
                                                    "
                                                    placeholder="Enter First Name"
                                                    v-model="
                                                        new_address.first_name
                                                    "
                                                    data-vv-as="First Name"
                                                />
                                                <label>First Name</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addaddressform.first_name'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "addaddressform.first_name"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="last_name"
                                                    name="last_name"
                                                    class="form-control bg-transparent"
                                                    v-validate="
                                                        'required|max:150'
                                                    "
                                                    placeholder="Enter Last Name"
                                                    v-model="
                                                        new_address.last_name
                                                    "
                                                    data-vv-as="Last Name"
                                                />
                                                <label>Last Name</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addaddressform.last_name'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "addaddressform.last_name"
                                                        )
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Row 4: Address 1 (left) + Address 2 (right) -->
                                    <div class="row edit_name_row">
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="address1"
                                                    name="address1"
                                                    class="form-control bg-transparent"
                                                    v-validate="
                                                        'required|max:150'
                                                    "
                                                    placeholder="Enter Address 1"
                                                    v-model="
                                                        new_address.address1
                                                    "
                                                    data-vv-as="Address1"
                                                />
                                                <label>Address 1</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addaddressform.address1'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "addaddressform.address1"
                                                        )
                                                    }}</small
                                                >
                                                <small
                                                    class="form-text text-error text-left font-weight-bold"
                                                    v-if="address1_suggestion"
                                                    >Suggestion:
                                                    {{
                                                        address1_suggestion
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="address2"
                                                    name="address2"
                                                    class="form-control bg-transparent"
                                                    v-model="
                                                        new_address.address2
                                                    "
                                                    placeholder="Enter Address 2"
                                                    data-vv-as="Address2"
                                                />
                                                <label>Address 2</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addaddressform.address2'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "addaddressform.address2"
                                                        )
                                                    }}</small
                                                >
                                                <small
                                                    class="form-text text-error text-left font-weight-bold"
                                                    v-if="address2_suggestion"
                                                    >Suggestion:
                                                    {{
                                                        address2_suggestion
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Row 5: City (left) + State (right) -->
                                    <div class="row edit_name_row">
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="city"
                                                    name="city"
                                                    class="form-control bg-transparent"
                                                    v-validate="
                                                        'required|max:150'
                                                    "
                                                    placeholder="Enter City"
                                                    v-model="new_address.city"
                                                    data-vv-as="City"
                                                />
                                                <label>City</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addaddressform.city'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "addaddressform.city"
                                                        )
                                                    }}</small
                                                >
                                                <small
                                                    class="form-text text-error text-left font-weight-bold"
                                                    v-if="city_suggestion"
                                                    >Suggestion:
                                                    {{ city_suggestion }}</small
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-lg-6">
                                            <div
                                                class="form-group edit_state_zip_div state_formgroup"
                                            >
                                                <fieldset>
                                                    <v-select
                                                        autocomplete="US"
                                                        label="code"
                                                        :reduce="
                                                            (name) => name.code
                                                        "
                                                        :options="states"
                                                        :placeholder="'Select State'"
                                                        name="state"
                                                        v-validate="'required'"
                                                        v-model="
                                                            new_address.state
                                                        "
                                                        data-vv-as="State"
                                                    ></v-select>
                                                    <label
                                                        class="state_label_new"
                                                        >State</label
                                                    >
                                                    <small
                                                        class="form-text text-error text-left"
                                                        v-show="
                                                            errors.has(
                                                                'addaddressform.state'
                                                            )
                                                        "
                                                        >{{
                                                            errors.first(
                                                                "addaddressform.state"
                                                            )
                                                        }}</small
                                                    >
                                                    <small
                                                        class="form-text text-error text-left font-weight-bold"
                                                        v-if="state_suggestion"
                                                        >Suggestion:
                                                        {{
                                                            state_suggestion
                                                        }}</small
                                                    >
                                                </fieldset>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Row 6: Zip / Postal code (left column) -->
                                    <div class="row edit_name_row">
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="zipcode"
                                                    name="zipcode"
                                                    placeholder="Enter Zipcode"
                                                    class="form-control bg-transparent mb-0"
                                                    v-validate="
                                                        'required|max:7|integer'
                                                    "
                                                    v-model="
                                                        new_address.pincode
                                                    "
                                                    data-vv-as="Zipcode"
                                                />

                                                <label>Zip / Postal code</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addaddressform.zipcode'
                                                        )
                                                    "
                                                    >{{
                                                        errors.first(
                                                            "addaddressform.zipcode"
                                                        )
                                                    }}</small
                                                >
                                                <small
                                                    class="form-text text-error text-left font-weight-bold"
                                                    v-if="pincode_suggestion"
                                                    >Suggestion:
                                                    {{
                                                        pincode_suggestion
                                                    }}</small
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <button
                                        type="submit"
                                        class="btn btn_orange bg_primary_orange text_white px_60 mt_34 mb_32"
                                    >
                                        Add
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";
import DeleteResource from "@/components/DeletePopup";
import CommonData from "@/common/common.data";
export default {
    name: "MyAddresses",
    components: { DeleteResource },
    data() {
        return {
            isLoader: false,
            new_address: {
                address_title: "",
                address_type: "",
                first_name: "",
                last_name: "",
                address_label: "",
                address1: "",
                address2: "",
                city: "",
                state: "",
                country: "US",
                pincode: "",
                address_verified: 0
            },
            address1_suggestion: null,
            address2_suggestion: null,
            city_suggestion: null,
            pincode_suggestion: null,
            state_suggestion: null,
            states: [],
            addresses: [],
            address_types: CommonData.address_types,
            CommonData: CommonData,
            address_type_error: ""
        };
    },
    mounted() {
        this.getAddresses();
        this.getStates();
        /* eslint-disable */
        if (typeof $ !== "undefined") {
            const $addModal = $("#add-address-modal");
            $addModal.off(
                "show.bs.modal.myaddresses hidden.bs.modal.myaddresses"
            );
            $addModal.on("show.bs.modal.myaddresses", () => {
                this.resetAddress();
            });
            $addModal.on("hidden.bs.modal.myaddresses", () => {
                this.resetAddress();
            });
        }
        /* eslint-enable */
    },
    methods: {
        onChangeAddressType(address_type, id = null) {
            this.address_type_error = "";
            if (
                address_type != "Additional Shipping Address" &&
                address_type != "Additional Billing Address"
            ) {
                if (id == null) {
                    let address = this.addresses.find(
                        (add) => add.address_type == address_type
                    );
                    if (address != undefined) {
                        this.address_type_error =
                            address_type + " has been selected already";
                    }
                } else {
                    let address = this.addresses.find(
                        (add) =>
                            add.address_type == address_type && add.id != id
                    );
                    if (address != undefined) {
                        this.address_type_error =
                            address_type + " has been selected already";
                    }
                }
            }
        },
        getAddresses() {
            this.isLoader = true;
            return new Promise(() => {
                ApiService.get("/user-saved-addresses")
                    .then(({ data }) => {
                        this.addresses = data.addresses;
                        this.isLoader = false;
                    })
                    .catch((response) => {
                        this.isLoader = false;
                        console.log(response);
                    });
            });
        },
        addUserAddress() {
            this.$validator
                .validateAll("addaddressform")
                .then(async (isValid) => {
                    if (!isValid || this.address_type_error != "") {
                        return;
                    }

                    let response = await this.verifyAddressWithUSPS(
                        this.new_address
                    );
                    if (!response.success) {
                        return;
                    }

                    this.isLoader = true;
                    ApiService.post("/address-book", this.new_address)
                        .then(({ data }) => {
                            this.isLoader = false;
                            
                            // Check for error response
                            if (data && !data.success) {
                                // Extract error message - handle both string and object formats
                                let errorMessage = "Failed to add address";
                                if (typeof data.error === 'string') {
                                    errorMessage = data.error;
                                } else if (data.error && typeof data.error === 'object') {
                                    errorMessage = data.error.error || data.error.message || "Failed to add address";
                                } else if (data.error) {
                                    errorMessage = String(data.error);
                                }
                                
                                this.$toast.error(errorMessage, {
                                    position: "top-right",
                                    queue: true,
                                    duration: 5000
                                });
                                return;
                            }
                            
                            this.city_suggestion = null;
                            this.pincode_suggestion = null;
                            /* eslint-disable */
                            $("#add-address-modal").modal("hide");
                            /* eslint-enable */
                            this.resetAddress();
                            this.address_type_error = "";
                            this.getAddresses();
                        })
                        .catch((error) => {
                            this.isLoader = false;
                            console.error("Address creation error:", error);
                            
                            // Handle error response - extract only the error message string
                            let errorMessage = "Failed to add address";
                            if (error.response && error.response.data) {
                                const errorData = error.response.data;
                                if (typeof errorData.error === 'string') {
                                    errorMessage = errorData.error;
                                } else if (errorData.error && typeof errorData.error === 'object') {
                                    errorMessage = errorData.error.error || errorData.error.message || String(errorData.error);
                                } else if (errorData.error) {
                                    errorMessage = String(errorData.error);
                                }
                            } else if (error.data) {
                                if (typeof error.data.error === 'string') {
                                    errorMessage = error.data.error;
                                } else if (error.data.error && typeof error.data.error === 'object') {
                                    errorMessage = error.data.error.error || error.data.error.message || String(error.data.error);
                                } else if (error.data.error) {
                                    errorMessage = String(error.data.error);
                                }
                            } else if (typeof error === 'string') {
                                errorMessage = error;
                            }
                            
                            this.$toast.error(errorMessage, {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                        });
                });
        },
        async updateUserAddress(address) {
            if (this.address_type_error == "") {
                let response = await this.verifyAddressWithUSPS(address);
                if (!response.success) {
                    return;
                }

                // If address1 or address2 has a suggestion, don't proceed with update - keep modal open
                if (this.address1_suggestion || this.address2_suggestion) {
                    this.isLoader = false;
                    return; // Keep modal open so user can see and apply the suggestion
                }

                this.$validator
                    .validateAll(`updateaddressform${address.id}`)
                    .then((isValid) => {
                        if (!isValid) {
                            return;
                        }

                        let update_address = {
                            address_id: address.id,
                            address_title: address.address_title,
                            first_name: address.first_name,
                            last_name: address.last_name,
                            address_label: address.address_label,
                            address1: address.address1,
                            address2: address.address2,
                            city: address.city,
                            state: address.state,
                            country: address.country,
                            pincode: address.pincode,
                            address_verified: address.address_verified,
                            address_type: address.address_type
                        };
                        this.isLoader = true;
                        ApiService.post("/update-user-address", update_address)
                            .then(({ data }) => {
                                this.isLoader = false;
                                
                                // Check for error response
                                if (data && !data.success) {
                                    // Extract error message - handle both string and object formats
                                    let errorMessage = "Failed to update address";
                                    if (typeof data.error === 'string') {
                                        errorMessage = data.error;
                                    } else if (data.error && typeof data.error === 'object') {
                                        errorMessage = data.error.error || data.error.message || "Failed to update address";
                                    } else if (data.error) {
                                        errorMessage = String(data.error);
                                    }
                                    
                                    this.$toast.error(errorMessage, {
                                        position: "top-right",
                                        queue: true,
                                        duration: 5000
                                    });
                                    return;
                                }
                                
                                this.city_suggestion = null;
                                this.pincode_suggestion = null;
                                this.address1_suggestion = null;
                                this.address2_suggestion = null;
                                this.state_suggestion = null;
                                /* eslint-disable */
                                $(`#update-address-modal${address.id}`).modal(
                                    "hide"
                                );
                                /* eslint-enable */
                                this.getAddresses();
                            })
                            .catch((error) => {
                                this.isLoader = false;
                                console.error("Address update error:", error);
                                
                                // Handle error response - extract only the error message string
                                let errorMessage = "Failed to update address";
                                if (error.response && error.response.data) {
                                    const errorData = error.response.data;
                                    if (typeof errorData.error === 'string') {
                                        errorMessage = errorData.error;
                                    } else if (errorData.error && typeof errorData.error === 'object') {
                                        errorMessage = errorData.error.error || errorData.error.message || String(errorData.error);
                                    } else if (errorData.error) {
                                        errorMessage = String(errorData.error);
                                    }
                                } else if (error.data) {
                                    if (typeof error.data.error === 'string') {
                                        errorMessage = error.data.error;
                                    } else if (error.data.error && typeof error.data.error === 'object') {
                                        errorMessage = error.data.error.error || error.data.error.message || String(error.data.error);
                                    } else if (error.data.error) {
                                        errorMessage = String(error.data.error);
                                    }
                                } else if (typeof error === 'string') {
                                    errorMessage = error;
                                }
                                
                                this.$toast.error(errorMessage, {
                                    position: "top-right",
                                    queue: true,
                                    duration: 5000
                                });
                                console.log(response);
                            });
                        this.address_type_error = "";
                    });
            }
        },
        getStates() {
            return new Promise((resolve, reject) => {
                ApiService.get("/states")
                    .then(({ data }) => {
                        this.states = data.states;
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        if (response.status == 401) {
                            this.$router.push({ name: "/admin/login" });
                        }
                        reject(response);
                    });
            });
        },
        resetAddress() {
            this.new_address = {
                address_title: "",
                address_type: "",
                first_name: "",
                last_name: "",
                address_label: "",
                address1: "",
                address2: "",
                city: "",
                state: "",
                country: "US",
                pincode: "",
                address_verified: 0
            };
            this.address_type_error = "";
            this.resetSuggestions();
            this.$validator.reset();
        },
        resetSuggestions() {
            this.address1_suggestion = null;
            this.address2_suggestion = null;
            this.city_suggestion = null;
            this.pincode_suggestion = null;
            this.state_suggestion = null;
            this.address_type_error = "";
        },
        verifyAddressWithUSPS(address) {
            this.isLoader = true;
            let params = {
                address1: address.address1,
                address2: address.address2,
                addressstate: address.state,
                city: address.city,
                addresszip: address.pincode
            };
            address.address_verified = 0;
            this.resetSuggestions();
            return new Promise((resolve, reject) => {
                ApiService.post("/verifyAddress/usps", params)
                    .then(({ data }) => {
                        // Check for error response first
                        if (!data.success) {
                            this.isLoader = false;
                            const errorMessage = data.error || "Address validation failed";
                            console.error("USPS Address Validation Error:", errorMessage);
                            this.$toast.error(errorMessage, {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            reject(data);
                            return;
                        }

                        // Handle new USPS Addresses 3.0 API response structure
                        if (!data.result) {
                            this.isLoader = false;
                            console.error("USPS Address Validation Error: No result in response", data);
                            this.$toast.error("Invalid response from address validation service", {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            reject({ success: false, error: "Invalid response from address validation service" });
                            return;
                        }

                        const result = data.result;
                        const addressData = result.address || {};
                        const additionalInfo = result.additionalInfo || {};

                        // Check DPVConfirmation - valid values are "Y" (Confirmed), "S" (Secondary confirmed), "D" (Default confirmed)
                        // "N" (Not confirmed) is invalid
                        const validDPVConfirmations = ["Y", "S", "D"];
                        if (!validDPVConfirmations.includes(additionalInfo.DPVConfirmation)) {
                            this.isLoader = false;
                            console.error("USPS Address Validation Error: DPVConfirmation is not valid", additionalInfo);
                            this.$toast.error("Invalid ZIP Code", {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            reject({ success: false, error: "Invalid ZIP Code" });
                            return;
                        }

                        // Check if address is vacant
                        if (additionalInfo.vacant === "Y") {
                            this.$toast.warning("This address is marked as vacant", {
                                position: "top-right",
                                queue: true
                            });
                        }

                        // Show warnings if any
                        if (result.warnings && result.warnings.length > 0) {
                            result.warnings.forEach(warning => {
                                this.$toast.warning(warning.message || "Address validation warning", {
                                    position: "top-right",
                                    queue: true
                                });
                            });
                        }

                        // Validate ZIP code first - if ZIP is wrong, reject
                        if (addressData.ZIPCode && address.pincode != addressData.ZIPCode) {
                            this.isLoader = false;
                            this.pincode_suggestion = addressData.ZIPCode;
                            this.$toast.error("Invalid Zip / PostalCode", {
                                position: "top-right",
                                queue: true
                            });
                            reject(data);
                            return;
                        }

                        // Validate state - if state is wrong, reject
                        if (addressData.state && address.state != addressData.state) {
                            this.isLoader = false;
                            this.state_suggestion = addressData.state;
                            this.$toast.error("Invalid State", {
                                position: "top-right",
                                queue: true
                            });
                            reject(data);
                            return;
                        }

                        // Validate city - if city is wrong, reject
                        if (addressData.city && address.city.toLowerCase() != addressData.city.toLowerCase()) {
                            this.isLoader = false;
                            this.city_suggestion = addressData.city;
                            this.$toast.error("Invalid City", {
                                position: "top-right",
                                queue: true
                            });
                            reject(data);
                            return;
                        }

                        // If ZIP code is correct but address1 doesn't match, show correction (not error)
                        if (addressData.streetAddress && address.address1.toLowerCase() != addressData.streetAddress.toLowerCase()) {
                            this.address1_suggestion = addressData.streetAddress;
                            this.$toast.info(`Address correction: ${addressData.streetAddress}`, {
                                position: "top-right",
                                queue: true,
                                duration: 5000
                            });
                            // Don't reject - allow address to be saved with correction suggestion
                        }

                        // Validate Address 2 (secondaryAddress) - show correction only if content is different and meaningful
                        if (addressData.secondaryAddress && address.address2 && address.address2.trim()) {
                            // Normalize both for comparison (trim and lowercase)
                            const userAddress2 = address.address2.trim().toLowerCase();
                            const uspsAddress2 = addressData.secondaryAddress.trim().toLowerCase();
                            
                            // Only show suggestion if content is actually different (case-insensitive comparison)
                            // And if USPS suggestion is meaningful (not just "# R" or very short ambiguous values)
                            if (userAddress2 !== uspsAddress2) {
                                // Filter out ambiguous or very short suggestions like "# R", "#", etc.
                                const uspsTrimmed = addressData.secondaryAddress.trim();
                                const isMeaningfulSuggestion = uspsTrimmed.length > 2 && 
                                    !(/^#\s*[A-Z]$/i.test(uspsTrimmed)); // Don't show suggestions like "# R", "# A", etc.
                                
                                if (isMeaningfulSuggestion) {
                                    this.address2_suggestion = addressData.secondaryAddress;
                                    this.$toast.info(`Address 2 correction: ${addressData.secondaryAddress}`, {
                                        position: "top-right",
                                        queue: true,
                                        duration: 5000
                                    });
                                    // Don't reject - allow address to be saved with correction suggestion
                                }
                            }
                        } else if (addressData.secondaryAddress && (!address.address2 || !address.address2.trim())) {
                            // If USPS returned secondaryAddress but user didn't enter address2, suggest it only if meaningful
                            const uspsTrimmed = addressData.secondaryAddress.trim();
                            const isMeaningfulSuggestion = uspsTrimmed.length > 2 && 
                                !(/^#\s*[A-Z]$/i.test(uspsTrimmed)); // Don't show suggestions like "# R", "# A", etc.
                            
                            if (isMeaningfulSuggestion) {
                                this.address2_suggestion = addressData.secondaryAddress;
                                this.$toast.info(`Address 2 suggestion: ${addressData.secondaryAddress}`, {
                                    position: "top-right",
                                    queue: true,
                                    duration: 5000
                                });
                                // Don't reject - allow address to be saved with suggestion
                            }
                        }

                        address.address_verified = 1;
                        this.isLoader = false;
                        resolve(data);
                    })
                    .catch((error) => {
                        this.isLoader = false;
                        console.error("USPS Address Validation API Error:", error);
                        // Handle different error formats
                        let errorMessage = "Address validation failed";
                        
                        if (error.response && error.response.data) {
                            errorMessage = error.response.data.error || error.response.data.message || errorMessage;
                        } else if (error.data && error.data.error) {
                            errorMessage = error.data.error;
                        } else if (error.error) {
                            errorMessage = error.error;
                        } else if (typeof error === 'string') {
                            errorMessage = error;
                        }
                        
                        this.$toast.error(errorMessage, {
                            position: "top-right",
                            queue: true,
                            duration: 5000
                        });
                        reject(error);
                    });
            });
        }
    }
};
</script>
